// Action creators extracted from ChatContainerModule.js

import {
  UPDATE_CHAT_INFO,
  UPDATE_TEXT_BOX_FOCUS_STATE,
  SET_DRAFT_MESSAGE_DATA,
} from "./ChatContainerConstants";

// Action Creators
export const updateChatInfo = data => {
  return {
    type: UPDATE_CHAT_INFO,
    data,
  };
};

export const updateTextboxFocus = data => {
  return {
    type: UPDATE_TEXT_BOX_FOCUS_STATE,
    data,
  };
};

export const setDraftMessageData = data => {
  return {
    type: SET_DRAFT_MESSAGE_DATA,
    data,
  };
};
